<template>
  <div class="download-container">
    <FileViewBackground />
    <div class="status-container">
      <div class="status-text">
        <template v-if="fileUrl === 0">加载中...</template>
        <template v-else-if="fileUrl === -1">没有找到该文件</template>
        <template v-else>
          {{ "下载链接已生成：" + easyFile.name }}
          <div class="file-size">{{ formatBytes(easyFile.size) }}</div>
        </template>
      </div>
      <img
        v-if="fileUrl === 0"
        class="loading-icon"
        src="../../../assets/loading-icon.svg"
      />
    </div>

    <div
      v-if="fileUrl !== 0 && fileUrl !== -1"
      class="download-btn"
      @click="$emit('download')"
    >
      点击下载
    </div>
  </div>
</template>

<script setup>
import FileViewBackground from "./EasyBackground.vue";

defineProps({
  fileUrl: {
    type: [Number, String],
    required: true,
  },
  easyFile: {
    type: Object,
    required: true,
  },
});

defineEmits(["download"]);

function formatBytes(bytes) {
  if (bytes < 1024) {
    return (bytes / 1024).toFixed(2) + " KB";
  } else if (bytes < 1048576) {
    return (bytes / 1024).toFixed(2) + " KB";
  } else if (bytes < 1073741824) {
    return (bytes / 1048576).toFixed(2) + " MB";
  } else {
    return (bytes / 1073741824).toFixed(2) + " GB";
  }
}
</script>

<style scoped lang="scss">
// 移动端样式
@media screen and (max-width: 768px) {
  .download-container {
    width: 100%;
    height: 100%;
    position: relative;

    .status-container {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      height: 56.25vw;
      width: 100%;
      margin: auto;
      background: black;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .status-text {
        font-size: 3.33vw;
        color: white;
        font-family: "思源黑体 Medium";
        text-align: center;

        .file-size {
          margin-top: 2.78vw;
          font-weight: 100;
          opacity: 0.5;
        }
      }

      .loading-icon {
        margin-top: 4.63vw;
        width: 4.63vw;
        height: 4.63vw;
        animation: spin 1.5s linear infinite;
      }
    }

    .download-btn {
      cursor: pointer;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 8.33vh;
      margin-left: auto;
      margin-right: auto;
      width: 64.81vw;
      height: 12.96vw;
      background: white;
      color: black;
      border-radius: 3.7vw;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: "思源黑体 Bold";
      font-size: 3.7vw;
    }
  }
}

// PC端样式
@media screen and (min-width: 769px) {
  .download-container {
    width: 100%;
    height: 100%;
    position: relative;

    .status-container {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      height: 39.06vh;
      width: 69.44vh;
      margin: auto;
      background: black;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .status-text {
        font-size: 2.59vh;
        color: white;
        font-family: "思源黑体 Medium";
        text-align: center;

        .file-size {
          margin-top: 2.78vh;
          font-weight: 100;
          opacity: 0.5;
        }
      }

      .loading-icon {
        margin-top: 2.78vh;
        width: 2.78vh;
        height: 2.78vh;
        animation: spin 1.5s linear infinite;
      }
    }

    .download-btn {
      cursor: pointer;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 7.41vh;
      margin-left: auto;
      margin-right: auto;
      width: 37.5vh;
      height: 7.5vh;
      background: white;
      color: black;
      border-radius: 3.75vw;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: "思源黑体 Bold";
      font-size: 2.41vh;
    }
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
